// src/modules/wallet/WalletApi.ts
import apiClient from '@skygroup/shared/API/apiClient';
import endpoints from '@skygroup/shared/API/endpoints';
import type {
    SendOtpRequest,
    SendOtpResponse,
    VerifyOtpRequest,
    VerifyOtpResponse,
    GetProfileResponse,
    LogoutResponse,
    UpdateProfileRequest,
    UpdateProfileResponse,
    StartPhoneChangeRequest,
    StartPhoneChangeResponse,
    VerifyPhoneChangeRequest,
    VerifyPhoneChangeResponse,
    RegisterRequest,
    RegisterResponse,
} from './membershipInterface';


// /**
//  * Send OTP to phone number
//  * @param data - Phone number in E.164 format
//  * @returns Promise with send confirmation
//  */
// export const sendOtp = async (data: SendOtpRequest): Promise<SendOtpResponse> => {
//     try {
//         const response = await apiClient.post<SendOtpResponse>(
//             endpoints.MEMBERSHIP.SEND_OTP,
//             data,
//             { withCredentials: true }
//         );

//         if (response.data.status !== 'success') {
//             throw new Error(response.data.message || 'Failed to send OTP');
//         }

//         return response.data;
//     } catch (error: any) {
//         const errorMessage = error?.response?.data?.message ||
//             error?.response?.data?.errors ||
//             error?.message ||
//             'Failed to send OTP';
//         throw new Error(Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage);
//     }
// };

// /**
//  * Verify OTP code and authenticate user
//  * Sets b2c_session cookie automatically
//  * @param data - Phone, OTP code, and optional profile info
//  * @returns Promise with member data
//  */
// const verifyOtp = async (data: VerifyOtpRequest): Promise<VerifyOtpResponse> => {
//     try {
//         const response = await apiClient.post<VerifyOtpResponse>(
//             endpoints.MEMBERSHIP.VERIFY_OTP,
//             {
//                 phone: data.phone,
//                 code: data.code,
//                 email: data.email,
//                 firstName: data.firstName,
//                 lastName: data.lastName,
//                 locale: data.locale,
//             },
//             { withCredentials: true }
//         );

//         if (response.data.status !== 'success') {
//             throw new Error(response.data.message || 'Failed to verify OTP');
//         }

//         return response.data;
//     } catch (error: any) {
//         const errorMessage = error?.response?.data?.message ||
//             error?.response?.data?.errors ||
//             error?.message ||
//             'Failed to verify OTP';
//         throw new Error(Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage);
//     }
// };

// /**
//  * Get current authenticated member profile
//  * Requires b2c_session cookie
//  * @returns Promise with member and session data
//  */
// const getProfile = async (): Promise<GetProfileResponse> => {
//     try {
//         const response = await apiClient.get<GetProfileResponse>(
//             endpoints.MEMBERSHIP.GET_PROFILE,
//             { withCredentials: true }
//         );

//         if (response.data.status !== 'success') {
//             throw new Error(response.data.message || 'Failed to get profile');
//         }

//         return response.data;
//     } catch (error: any) {
//         if (error?.response?.status === 401) {
//             throw new Error('Unauthorized - Please log in again');
//         }
//         const errorMessage = error?.response?.data?.message ||
//             error?.response?.data?.errors ||
//             error?.message ||
//             'Failed to get profile';
//         throw new Error(Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage);
//     }
// };

// /**
//  * Logout current session
//  * Clears b2c_session cookie automatically
//  * @returns Promise with logout confirmation
//  */
// const logout = async (): Promise<LogoutResponse> => {
//     try {
//         const response = await apiClient.post<LogoutResponse>(
//             endpoints.MEMBERSHIP.LOGOUT,
//             {},
//             { withCredentials: true }
//         );

//         if (response.data.status !== 'success') {
//             throw new Error(response.data.message || 'Failed to logout');
//         }

//         return response.data;
//     } catch (error: any) {
//         if (error?.response?.status === 401) {
//             // Already logged out or session expired, return success
//             return {
//                 status: 'success',
//                 message: 'Logged out successfully',
//                 data: {} as Record<string, never>,
//             };
//         }
//         const errorMessage = error?.response?.data?.message ||
//             error?.response?.data?.errors ||
//             error?.message ||
//             'Failed to logout';
//         throw new Error(Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage);
//     }
// };

// /**
//  * Update member profile
//  * Requires b2c_session cookie
//  * @param data - Profile fields to update
//  * @returns Promise with updated member data
//  */
// const updateProfile = async (data: UpdateProfileRequest): Promise<UpdateProfileResponse> => {
//     try {
//         const response = await apiClient.patch<UpdateProfileResponse>(
//             endpoints.MEMBERSHIP.UPDATE_PROFILE,
//             {
//                 firstName: data.firstName,
//                 lastName: data.lastName,
//                 email: data.email,
//                 locale: data.locale,
//             },
//             { withCredentials: true }
//         );

//         if (response.data.status !== 'success') {
//             throw new Error(response.data.message || 'Failed to update profile');
//         }

//         return response.data;
//     } catch (error: any) {
//         if (error?.response?.status === 401) {
//             throw new Error('Unauthorized - Please log in again');
//         }
//         const errorMessage = error?.response?.data?.message ||
//             error?.response?.data?.errors ||
//             error?.message ||
//             'Failed to update profile';
//         throw new Error(Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage);
//     }
// };

// /**
//  * Start phone number change process
//  * Sends OTP to new phone number
//  * Requires b2c_session cookie
//  * @param data - New phone number in E.164 format
//  * @returns Promise with changeToken for verification
//  */
// const startPhoneChange = async (data: StartPhoneChangeRequest): Promise<StartPhoneChangeResponse> => {
//     try {
//         const response = await apiClient.post<StartPhoneChangeResponse>(
//             endpoints.MEMBERSHIP.START_PHONE_CHANGE,
//             {
//                 newPhone: data.newPhone,
//             },
//             { withCredentials: true }
//         );

//         if (response.data.status !== 'success') {
//             throw new Error(response.data.message || 'Failed to start phone change');
//         }

//         return response.data;
//     } catch (error: any) {
//         if (error?.response?.status === 401) {
//             throw new Error('Unauthorized - Please log in again');
//         }
//         if (error?.response?.status === 409) {
//             throw new Error('Phone number is already in use by another member');
//         }
//         const errorMessage = error?.response?.data?.message ||
//             error?.response?.data?.errors ||
//             error?.message ||
//             'Failed to start phone change';
//         throw new Error(Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage);
//     }
// };

// /**
//  * Verify phone number change with OTP
//  * Updates phone number and refreshes session
//  * Requires b2c_session cookie
//  * @param data - ChangeToken and OTP code
//  * @returns Promise with updated member data
//  */
// const verifyPhoneChange = async (data: VerifyPhoneChangeRequest): Promise<VerifyPhoneChangeResponse> => {
//     try {
//         const response = await apiClient.post<VerifyPhoneChangeResponse>(
//             endpoints.MEMBERSHIP.VERIFY_PHONE_CHANGE,
//             {
//                 changeToken: data.changeToken,
//                 code: data.code,
//             },
//             { withCredentials: true }
//         );

//         if (response.data.status !== 'success') {
//             throw new Error(response.data.message || 'Failed to verify phone change');
//         }

//         return response.data;
//     } catch (error: any) {
//         if (error?.response?.status === 401) {
//             throw new Error('Unauthorized - Please log in again');
//         }
//         if (error?.response?.status === 409) {
//             throw new Error('Phone number is already in use by another member');
//         }
//         const errorMessage = error?.response?.data?.message ||
//             error?.response?.data?.errors ||
//             error?.message ||
//             'Failed to verify phone change';
//         throw new Error(Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage);
//     }
// };

/**
 * Register a new member
 * @param data - Phone, first name, last name, optional email
 * @returns Promise with registration result
 */
export const register = async (data: RegisterRequest): Promise<RegisterResponse> => {
    try {
        const response = await apiClient.post<RegisterResponse>(
            endpoints.AUTH.REGISTER_MEMBERSHIP,
            {
                phone: data.phone,
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                newsletter: data.newsletter,
            },
            { withCredentials: true }
        );

        if (response.data.status !== 'success') {
            throw new Error(response.data.message);
        }

        return response.data;
    } catch (error: any) {
        const errorMessage = error?.response?.data?.message ||
            error?.response?.data?.errors ||
            error?.message;
        throw new Error(Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage);
    }
};

export interface UpdateMemberRequest {
    secret: string;
    phone: string;
    first_name: string;
    last_name: string;
    email?: string;
    newsletter?: boolean;
}

/**
 * Update member profile (no phone change).
 * @param data - first_name, last_name, optional email and newsletter
 * @returns Promise with updated membership user data
 */
export const updateMember = async (data: UpdateMemberRequest) => {
    try {
        const response = await apiClient.post(
            endpoints.AUTH.UPDATE_MEMBERSHIP,
            {
                secret: data.secret,
                phone: data.phone,
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                newsletter: data.newsletter,
            },
            { withCredentials: true }
        );

        if (response.data?.status !== 'success') {
            throw new Error(response.data?.message);
        }

        return response.data;
    } catch (error: any) {
        const errorMessage = error?.response?.data?.message ||
            error?.response?.data?.errors ||
            error?.message;
        throw new Error(Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage);
    }
};